<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['lawyer-card-skeleton', { _mobile: isMobile }]">
    <div class="lawyer-card-skeleton__header">
      <Skeleton
        width="100%"
        :height="isMobile ? '80px' : '120px'"
        :max-width="isMobile ? '92px' : '120px'"
      />
      <Skeleton
        width="100%"
        :height="isMobile ? '165px' : '79px'"
        :max-width="isMobile ? '100%' : '257px'"
      />
    </div>
    <Skeleton width="100%" :height="isMobile ? '45px' : '232px'" />
  </div>
</template>

<style lang="less" scoped>
.lawyer-card-skeleton {
  .flex-column(@size-x5);
  .box-shadow();

  width: 100%;
  padding: @size-x5;

  &__header {
    display: flex;
    justify-content: space-between;
    gap: @size-x8;
  }

  &._mobile &__header {
    gap: @size-x4;
  }
}
</style>
